import React from 'react'
import {
  defineMessages,
  useIntl
} from 'react-intl'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import TextBodySmall from 'components/TextBodySmall/index.js'
import Chip from 'components/Chip/index.js'
import Row from 'components/Row.js'

const INTERVAL = 1000

const messages = defineMessages({
  ends: {
    id: 'Countdown.ends',
    defaultMessage: '⏳'
  },
  hours: {
    id: 'Countdown.hours',
    defaultMessage: '{count} hrs'
  },
  minutes: {
    id: 'Countdown.minutes',
    defaultMessage: '{count} min'
  },
  seconds: {
    id: 'Countdown.seconds',
    defaultMessage: '{count} sec'
  }
})

const calculateTimeLeftUtil = (endTime) => {
  if (!endTime || isNaN(new Date(endTime))) {
    return {
      hours: 0,
      minutes: 0,
      seconds: 0
    }
  }

  const difference = new Date(endTime) - new Date()

  if (difference <= 0) {
    return {
      hours: 0,
      minutes: 0,
      seconds: 0
    }
  }

  const totalSeconds = Math.floor(difference / 1000)

  return {
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60
  }
}

/**
 * @param end
 * @returns {JSX.Element}
 * @constructor
 */
export function Countdown ({
  end
}) {
  const intl = useIntl()
  const [start, setStart] = React.useState(new Date())
  const hasEnded = start > end
  const duration = hasEnded
    ? {
        hours: 0,
        minutes: 0,
        seconds: 0
      }
    : calculateTimeLeftUtil(end)

  React.useEffect(() => {
    let interval
    if (!hasEnded) {
      interval = setInterval(() => {
        setStart(new Date())
      }, INTERVAL)
    }
    return () => clearInterval(interval)
  }, [])

  return (
    <Chip>
      <Row style={{
        gap: '0.5rem'
      }}
      >

        <View>
          <TextBodySmall fw='700'>
            {formatMessageIntlUtil(intl, messages.ends)}
          </TextBodySmall>
        </View>

        {
          !!duration.hours && (
            <View>
              <TextBodySmall fw='700'>
                {formatMessageIntlUtil(intl, messages.hours, { count: duration.hours || 0 })}
              </TextBodySmall>
            </View>
          )
        }

        {
          <View>
            <TextBodySmall fw='700'>
              {formatMessageIntlUtil(intl, messages.minutes, { count: duration.minutes || 0 })}
            </TextBodySmall>
          </View>
        }

        {
          <View>
            <TextBodySmall fw='700'>
              {formatMessageIntlUtil(intl, messages.seconds, { count: duration.seconds || 0 })}
            </TextBodySmall>
          </View>
        }
      </Row>
    </Chip>
  )
}
